import React from 'react';
import classNames from 'classnames';
import { sortByAtoZtoNumber, SortOrder } from '../sortOrder';

interface ListProps<T> {
  items?: T[];
  renderItem: (item: T) => React.ReactNode;
  ulClassName?: string;
  liClassName?: string;
  sortBy?: keyof T | null;
  sortOrder?: SortOrder;
}

const List = <T extends { id: string | number }>({
  items,
  renderItem,
  ulClassName = '',
  liClassName = '',
  sortBy = null,
  sortOrder = 'ascending',
}: ListProps<T>) => {
  const sortedItems = sortBy
    ? items?.sort((a, b) =>
        sortByAtoZtoNumber(String(a[sortBy]), String(b[sortBy]), sortOrder),
      )
    : items;

  if (!sortedItems?.length) return null;

  return (
    <ul className={classNames('generic-list', { [`${ulClassName}`]: !!ulClassName })}>
      {sortedItems?.map((item) => (
        <li key={item.id} className={classNames({ [`${liClassName}`]: !!liClassName })}>
          {renderItem(item)}
        </li>
      ))}
    </ul>
  );
};

export default List;
